






































































import axios from 'axios';
import { Component, Vue } from 'vue-property-decorator';

import config from '../../utils/config';

@Component
export default class ContactSection extends Vue {
  customer: {
    email?: string;
    subject?: string;
    message?: string;
  } = {};

  isSending = false;

  contactMessage = '';

  submit() {
    this.isSending = true;
    axios
      .post(`${config.getAPIAddress()}/customer/`, this.customer)
      .then(() => {
        this.isSending = false;
        this.contactMessage = 'Mensagem enviado com sucesso. Em breve um consultor lhe contatará.';
      })
      .catch(() => {
        this.isSending = false;
        this.contactMessage = 'Erro ao enviar mensagem. Por favor, tente mais tarde.';
      });
  }
}
